//*** Import React Library
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { ChartCurrentRobotLevelSpraying } from "./ChartCurrentRobotLevelSpraying";
import Table from "react-data-table-component";
import Button from "react-bootstrap/Button";
import Axios from 'axios'
import "../../Assets/Styles/robot.css";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
import AxiosInstance from '../Axios/AxiosInstance';
//*** Create columns for react table
const columns = [
    { name: "Sr. No.", selector: (row) => row.id + 1, sortable: true },
    { name: "Robot Name", selector: (row) => row.robotName, sortable: true },
    { name: "Working Date", selector: (row) => row.workingDate, sortable: true },
    { name: "Area Covered (Cycles)", selector: (row) => row.areaCovered, sortable: true },
];

//*** Create custom style for react table
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
            /*  fontSize: "100%"*/
        },
    },
    headRow: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};
//*** Export Robot Level Spraying components
export const CurrentRobotLevelSpraying = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([])
    const [list, setList] = useState([])

    //*** Seach  Textbox text change event
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = data;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setList(filteredData);
        }
        if (event.target.value == "") {
            setList(data);
        }
    };
    //*** Filter table
    const filteredData = list.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    //const handleRowSelected = (rows) => {
    //    setData(rows.selectedRows);
    //};
    //const contextActions = (
    //    <button onClick={() => alert(data.map((r) => r.robotID))}>
    //        Show Selected Rows
    //    </button>
    //);

    //*** Use React hooks - if occur any changes on page then useffect() function will run auto
    useEffect(() => {
        fetchData();
    }, [])
    useEffect(() => {
        console.log(data)
    }, [data])

    //*** Fetch data from API
    const fetchData = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        try{ 
            const response = await AxiosInstance.get("/RobotLevelCurrentSprayingStatus?pid=" + plant_id + "");
            if (response && typeof response.then === 'function') {
            //const response = await Axios("/RobotLevelCurrentSprayingStatus?pid=" + plant_id + "");
                response.then((res) => {
                    if (res.data) {
                        setData(response.data)
                        setList(response.data)
                    }
                })
                response.catch(
                    function (error) {
                        console.log('Error Message:' + error)
                    }
                )
            }
            else {
                console.log("Response is not a promise");
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    // *** Return html code 
    return (
        <>
         {hasJWTToken() ? (
            <div>
                <h3 style={{ margin: "2%", marginLeft: "2%" }}>Current Robot Level Spraying</h3>
                <div
                style={{
                    border: "1px solid #c0c0c0",
                    borderRadius: "5px",
                    margin: "2%",
                    backgroundColor: "#fff",
                }}
              >
                <div className="container dvscroll" style={{ width: "100%", height: "70%", fontSize: "92%" }} >
                    <div className="row dvscroll">
                        <div className="col-sm-6">
                            <input
                                type="text"
                                placeholder="Search Results"
                                style={{
                                    width: "20%",
                                    height: "30px",
                                    margin: "10px",
                                    float: "right",
                                    border: "none",
                                    padding: "1.5%",
                                    borderRadius: "5px",
                                }}
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                            <p></p>
                            <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
                                search={true}
                                columns={columns}
                                data={filteredData}
                                highlightOnHover={true}
                                customStyles={customStyles}
                            >
                            </DataTable>
                        </div>
                        <div className="col-sm-6">
                            <ChartCurrentRobotLevelSpraying></ChartCurrentRobotLevelSpraying>
                        </div>
                    </div>
                </div>
                </div>
                </div>
             ) :
                (
                    <Route to={{ pathname: '#/login' }} />
                )
            }      
        </>
    );
};
